import * as React from "react";

// When a new release is deployed, tabs that loaded an older index.html try to
// fetch chunk URLs whose hash no longer exists, throwing
// "Failed to fetch dynamically imported module". One retry catches transient
// CDN propagation; if the second attempt still fails, force a hard reload so
// the tab picks up the new index.html.
export function lazyWithReload<T extends React.ComponentType<any>>(
    factory: () => Promise<{default: T}>
): React.LazyExoticComponent<T> {
    return React.lazy(() =>
        factory().catch(async () => {
            await new Promise(r => setTimeout(r, 200));
            try {
                return await factory();
            } catch (err) {
                if (typeof window !== "undefined") {
                    window.location.reload();
                }
                throw err;
            }
        })
    );
}
